import React from 'react';
import Flexbox from 'flexbox-react';
import { cx } from 'emotion';
import ProcessUtils from 'utils/ProcessUtils';
import ProcessWizardPage from 'components/page/process/wizard/ProcessWizardPage';
import DataExplorerPage from 'components/core/data_explorer/DataExplorerPage';
import DimensionsForm from 'components/core/forms/DimensionsForm';

export default class DimensionsPage extends ProcessWizardPage {
    static defaultProps = {
        title: 'Setup Output Dimensions',
        description: 'Define the coordinate data for each dimension of the output datastream.'
    };

    renderFormWithProcess() {
        const dimensionName = this.props.pageAttributes.dimensionName;

        return (
            <DataExplorerPage
                process = {this.props.process} 
                siteFacilities = {this.props.siteFacilities}
                exploredDatastreams = {this.props.exploredDatastreams}>
                {this.renderDimensionHeader()}
                <Flexbox flexGrow={1} flexDirection={'column'} className={cx(this.formStyles, this.overflowContainer)}>
                    <DimensionsForm
                        dimensionName={dimensionName}
                        process={this.props.process}
                        processErrors={this.props.processErrors}
                        coordinateSystemName={ProcessUtils.getWizardCoordinateSystemName(this.props.process)}
                        dimensionIsTime={dimensionName === 'time'}
                        hasWritePermissions={this.props.hasWritePermissions}
                    />
                </Flexbox>
            </DataExplorerPage>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/page/process/wizard/DimensionsPage.js